import { schema } from "normalizr";
import createProfileRecord from "records/instagram";

const InstagramSchema = new schema.Entity(
    "instagramPosts",
    {},
    {
        idAttribute: "id",
    }
);

InstagramSchema.record = createProfileRecord;

export default InstagramSchema;
